import { useOrganization } from '@/contexts/OrganizationContext';
import { getIndustryType } from '@/firebase/organizationService';
import { getOrganizationTypeConfig, OrganizationTypeConfig } from '@/services/organizationTypeConfig';

/**
 * Hook to get organization type configuration
 * Returns the configuration for the current organization's industry type
 */
export function useOrganizationType(): OrganizationTypeConfig {
  const { currentOrganization } = useOrganization();
  const organizationType = getIndustryType(currentOrganization);
  return getOrganizationTypeConfig(organizationType);
}

